import React from 'react'

const ImpressumPage: React.FC = () => {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-6">Impressum</h1>
      <div className="space-y-4 text-gray-700 dark:text-gray-200 text-sm leading-relaxed">
        <p><strong>Angaben gemäß § 5 DDG</strong></p>
        <p>
          Qualyz
          <br />
          Kim Haisch
          <br />
          Furtwänglerstraße 4
          <br />
          79117 Freiburg im Breisgau
        </p>
        <p>Kontakt: info@qualyz.de</p>
        <p>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV: Kim Haisch, Anschrift wie oben</p>
        <p><strong>Haftung:</strong> Keine Haftung. Nutzung der bereitgestellten Informationen erfolgt auf eigenes Risiko.
          Für Richtigkeit, Vollständigkeit und Aktualität der Inhalte wird keine Gewähr übernommen. Für externe Links
          wird keine Haftung übernommen.</p>
        <p>
          Urheberrecht: Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem
          deutschen Urheberrecht.
        </p>
      </div>
    </div>
  )
}

export default ImpressumPage
